import React, { useEffect, useRef, useState } from 'react';
import { Link, Outlet, useNavigate } from 'react-router-dom';
import authService from '../services/AuthService';
import clientService from '../services/ClientService';

const Layout = () => {
    const navigate = useNavigate();

    const [searchQuery, setSearchQuery] = useState('');
    const [searchLoading, setSearchLoading] = useState(false);
    const [searchError, setSearchError] = useState('');
    const [searchResults, setSearchResults] = useState([]);
    const [searchOpen, setSearchOpen] = useState(false);
    const searchRequestIdRef = useRef(0);

    const handleLogout = () => {
        authService.logout();
        navigate('/login');
        window.location.reload();
    };

    useEffect(() => {
        const q = searchQuery.trim();
        if (!q) {
            setSearchResults([]);
            setSearchError('');
            setSearchLoading(false);
            setSearchOpen(false);
            return;
        }

        const requestId = ++searchRequestIdRef.current;
        setSearchLoading(true);
        setSearchError('');
        setSearchOpen(true);

        const t = setTimeout(async () => {
            try {
                const response = await clientService.searchClients(q, 20);
                if (requestId !== searchRequestIdRef.current) return;
                setSearchResults(response.data || []);
            } catch (err) {
                if (requestId !== searchRequestIdRef.current) return;
                setSearchError('No se pudo buscar.');
                setSearchResults([]);
            } finally {
                if (requestId !== searchRequestIdRef.current) return;
                setSearchLoading(false);
            }
        }, 250);

        return () => clearTimeout(t);
    }, [searchQuery]);

    const handleSelectClient = (clientId) => {
        setSearchOpen(false);
        setSearchQuery('');
        setSearchResults([]);
        navigate(`/clients/${clientId}`);
    };

    return (
        <div className="flex">
            <nav className="w-64 h-screen bg-gray-800 text-white p-4">
                <h1 className="text-2xl font-bold mb-8">MikroNet</h1>

                <div className="mb-6 relative">
                    <input
                        type="text"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        placeholder="Busque aquí..."
                        className="w-full px-3 py-2 rounded text-gray-900"
                    />

                    {searchOpen && (searchLoading || searchError || searchResults.length > 0) && (
                        <div className="absolute mt-2 w-full bg-white text-gray-900 rounded shadow border max-h-64 overflow-auto z-10">
                            {searchLoading && (
                                <div className="px-3 py-2 text-sm text-gray-600">Buscando...</div>
                            )}
                            {searchError && (
                                <div className="px-3 py-2 text-sm text-red-600">{searchError}</div>
                            )}
                            {!searchLoading && !searchError && searchResults.length === 0 && (
                                <div className="px-3 py-2 text-sm text-gray-600">Sin resultados</div>
                            )}
                            {!searchLoading && !searchError && searchResults.map((c) => (
                                <button
                                    key={c.id}
                                    type="button"
                                    onClick={() => handleSelectClient(c.id)}
                                    className="w-full text-left px-3 py-2 hover:bg-gray-100"
                                >
                                    <div className="text-sm font-medium">{c.nombre}</div>
                                    <div className="text-xs text-gray-600">ID: {c.id}{c.movil ? ` · ${c.movil}` : ''}{c.correo ? ` · ${c.correo}` : ''}</div>
                                </button>
                            ))}
                        </div>
                    )}
                </div>

                <ul>
                    <li className="mb-4"><Link to="/" className="hover:text-blue-300">Dashboard</Link></li>
                    <li className="mb-4"><Link to="/routers" className="hover:text-blue-300">Gestionar Routers</Link></li>
                    <li className="mb-4"><Link to="/clients" className="hover:text-blue-300">Clientes</Link></li>
                    <li className="mb-4"><Link to="/history" className="hover:text-blue-300">Historial</Link></li>
                </ul>
                <button onClick={handleLogout} className="absolute bottom-4 bg-red-500 p-2 rounded w-56">Cerrar Sesión</button>
            </nav>
            <main className="flex-1 p-8 bg-gray-100">
                <Outlet />
            </main>
        </div>
    );
};

export default Layout;
